import { Injectable, inject } from '@angular/core';
import { PortalSettingsService } from '@core/services/portal-settings.service';
import { HRGetPRCo_Result } from '../../../type-definitions/admin/responses/admin';
import { AccountApiService } from './account.api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LoginCompanyInfo } from '../../../shared/model/login-company-info';

@Injectable({
  providedIn: 'root',
})
export class LoginFormService {
  private readonly portalSettings = inject(PortalSettingsService).getPortalSettings();
  private readonly accountApiService = inject(AccountApiService);

  getCompanyConfiguration(): Observable<LoginCompanyInfo> {
    const isCompanyDropdownSetting = this.portalSettings.CompanyLoginChoices.ConfigValue == '1';
    const logoCo = Number(this.portalSettings.LogoHQCo.ConfigValue);

    let isCoDropdownVisible = false;
    let isCompanySelection = false;
    const changeLogo = false;
    const defaultCompany = null;

    // Company dropdown
    if (isCompanyDropdownSetting) {
      return this.getCompanyDropdownInfo(logoCo);
    }
    // Company input
    else {
      isCoDropdownVisible = false;
      isCompanySelection = true;
      return new Observable<LoginCompanyInfo>(observer => {
        observer.next({
          isCoDropdownVisible,
          isCompanySelection,
          changeLogo,
          defaultCompany,
          coDropdownCompanies: null,
          logoUrl: this.getLogoUrl(logoCo),
        });
        observer.complete();
      });
    }
  }

  getDefaultCompany(companies: HRGetPRCo_Result[]): number {
    const defaultCompany = Number(this.portalSettings.DefaultLoginCompany.ConfigValue);
    const defaultDropdownCo = companies.find(co => co.PRCo == defaultCompany);
    if (defaultDropdownCo !== null && defaultDropdownCo !== undefined) {
      return defaultDropdownCo.PRCo;
    } else {
      return companies[0]?.PRCo;
    }
  }

  getLogoUrl(co: number, size = 'L'): string {
    return '/Company/GetLogo?co=' + co + '&size=' + size;
  }

  private getCompanyDropdownInfo(logoCo: number): Observable<LoginCompanyInfo> {
    return this.accountApiService.getCompanies().pipe(
      map(companies => {
        const isCoDropdownVisible = companies && companies.length > 1;
        const isCompanySelection = isCoDropdownVisible;
        const defaultCompany = this.getDefaultCompany(companies);
        const changeLogo = !logoCo;
        const logoUrl = this.getLogoUrl(logoCo ? logoCo : defaultCompany);
        return {
          isCoDropdownVisible,
          isCompanySelection,
          coDropdownCompanies: companies,
          logoUrl,
          changeLogo,
          defaultCompany: defaultCompany,
        };
      })
    );
  }
}
